<template>
  <v-container>
    <v-row class="Banner pa-8">
      <v-col cols="12" md="6"
        ><v-row align="center" justify="center" style="height: 100%">
          <v-col>
            <h1 id="Banner__lead" class="primary--text">
              Embrace real-time and easy-to-build polls.
            </h1>

            <p class="mt-5">
              Manage multiple poll agents and gain visibility into all poll data
              collected across your organization with administrator controls and
              dashboards.
            </p>
            <v-btn class="primary mt-4" large depressed :to="{ name: 'Auth' }"
              >Get started</v-btn
            >
          </v-col>
        </v-row></v-col
      >

      <v-col cols="12" md="6" class="d-none d-md-block d-lg-block pa-12">
        <v-row align="center" justify="center" style="height: 100%">
          <!-- <div
            style="
              width: 100%;
              height: 60%;
              background-color: gray;
              opacity: 20%;
            "
          ></div> -->
          <object
            width="100%"
            :data="require('@/assets/images/selecting.svg')"
            type="image/svg+xml"
          ></object>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Banner",
};
</script>

<style>
.Banner {
  min-height: 70vh;
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 50px 0s;
}

#Banner__lead {
  letter-spacing: -1.2px;
  line-height: 100%;
  font-size: 2.5rem;
}

@media (max-width: 960px) {
  /* below laptop */
  .Banner {
    text-align: center;
  }
}

@media (min-width: 960px) {
  /* laptop and above */
  /* .Banner {
    padding-left: 1.5rem;
  } */
}
</style>
